<div class="header">
  <div class="title">Link Tasks</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="linkedTaskForm">
  <i class="mb-5">The task selected below will populate the current task [{{ task.title }}] start and due date.</i>
  <!-- Subject -->
  <mat-form-field class="flex-auto gt-xs:pr-3">
    <mat-label>Task List to Link From:</mat-label>
    <mat-select (selectionChange)="onChangeSelectedTaskList($event)" [formControlName]="'task_list_id'">
      <mat-option *ngFor="let taskList of taskLists" [value]="taskList.id">
        {{ taskList.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Task to Link From:</mat-label>
    <mat-select [formControlName]="'linked_from_task_id'">
      <mat-option *ngFor="let dt of onlyTasks" [value]="dt.id">
        {{ dt.title }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        [disabled]="isSaveBtnDisabled"
        DebounceClick
        (debounceClick)="save()"
      >
        <span>Save</span>
      </button>
    </div>
  </div>
</form>
